export enum ViewType {
  SUITES = 'suites',
  PACKAGES = 'packages',
  CLASSES = 'classes',
  TESTS = 'tests',
}
